module.exports = __webpack_public_path__ + "img/PRNT_03_mono_AE_00003.77c3e5a7.png";